// utils/dateUtils.ts
export const careerDateFormat = (dateString?: string): string | undefined => {
    if (!dateString) {
        return undefined;
    }

    const date = new Date(dateString);
    const now = new Date();
    const diffTime = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
        return 'Posted today';
    }
    if (diffDays === 1) {
        return 'Posted yesterday';
    }
    if (diffDays < 30) {
        return `Posted ${diffDays} days ago`;
    }
    if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        return `Posted ${months} month${months > 1 ? 's' : ''} ago`;
    }
    const years = Math.floor(diffDays / 365);
    return `Posted ${years} year${years > 1 ? 's' : ''} ago`;
};
